import Box from "@mui/material/Box";
import { usePathname } from "src/routes/hooks";

import Footer from "./footer";
import Header from "./header";

import { useWhiteLabel } from "src/context/WhiteLabelContext";
import PlacenetAuthentication from "src/components/placenet-authentication/placenet-authentication";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: Props) {
  const pathname = usePathname();

  const homePage = pathname === "/";
  const isLiveCalendar = window.location.href.includes("livecalendar");

  const whitelabelConfig = useWhiteLabel();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: whitelabelConfig.backgroundColor,
      }}
    >
      <PlacenetAuthentication />

      {!whitelabelConfig.hideHeader && !isLiveCalendar && <Header />}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 3,
          ...(!homePage &&
            {
              // pt: { xs: 8, md: 10 },
            }),
        }}
      >
        {children}
      </Box>

      {!isLiveCalendar && !whitelabelConfig.hideFooter && <Footer />}
    </Box>
  );
}
